/* eslint-disable */
// @ts-nocheck

import { Plus, TrashOutline } from 'heroicons-react'
import { useContext, useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import {
  ArrowUturnLeftIcon,
  PencilIcon,
  PlusIcon,
  TrashIcon,
} from '@heroicons/react/24/outline'

import useServer from '@/api/useServerMain'
import useServerProduct from '@/api/useServerProducts'
import defaultImage from '@/assets/image-default.jpg'
import CustomRadio, { CustomRadioData } from '@/components/forms/CustomRadio'
import Input from '@/components/forms/Input'
import Select from '@/components/forms/Select'
import SingleRadio from '@/components/forms/SingleRadio'
import TextArea from '@/components/forms/TextArea'
import AlertContainer from '@/components/misc/AlertContainer'
import ProductTypeBadge from '@/components/misc/badges/ProductTypeBadge'
import Button from '@/components/misc/Button'
import EmptyList from '@/components/misc/EmptyList'
import GenericTable, {
  DataTableInterface,
} from '@/components/misc/GenericTable'
import { BtnActions } from '@/components/misc/MultipleActBtn'
import SearchComponent from '@/components/misc/SearchComponent'
import SpinnerLoading from '@/components/misc/SpinnerLoading'
import Modal from '@/components/modals/GenericModal'
import { SelectInterface } from '@/interfaces/InterfacesLocal'
import {
  FixedCost,
  ProductInterface,
  SuppliesInterface,
} from '@/interfaces/ServerInterfaces'
import { useAppSelector } from '@/store/hooks'
import { formatCurrency } from '@/utils/helpers'
import { translateMeasure } from '@/utils/translate'

import { DetailProductContext } from '../DetailProductContainer'

interface NewElement {
  addElement: Function
}

const currency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

const supplyNoAccess = ['RAW', 'VARIATION', 'INPUT', 'ASSET']
const performanceNoAccess = ['RAW', 'VARIATION', 'INPUT', 'ASSET']
const fixedCostNoAccess = ['ASSET']

//New Materia Prima Product Modal ---------------------------------------------------------------------------------------
const NewElement = ({ addElement }: NewElement) => {
  const { control, handleSubmit, getValues, setError, watch, clearErrors } =
    useForm()
  const { getAllProducts, allProducts, outLoading } = useServerProduct()
  const [search, setSearch] = useState<string | null>(null)

  const onSubmit: SubmitHandler<Record<string, string | number | boolean>> = (
    data
  ) => {
    const supplyProductId = getValues('supplyProductId')
    if (!supplyProductId) {
      toast.error('Busque y seleccione un producto', { autoClose: 5000 })
    } else {
      addElement({
        ...allProducts.find((prod) => prod.id === supplyProductId),
        quantity: data.quantity,
      })
    }
  }

  //Data for list product -----------------------------------------------------------------------
  useEffect(() => {
    search &&
      getAllProducts({
        type: 'RAW,MANUFACTURED,STOCK,WASTE,INPUT',
        search,
        all_data: true,
      })
  }, [search])

  const data: CustomRadioData[] = []
  search &&
    allProducts.map((product) =>
      data.push({
        value: product.id,
        name: product.name,
        img: product.images[0]?.src ?? defaultImage,
        elements: {
          type: <ProductTypeBadge type={product.type} />,
          measure: translateMeasure(product.measure),
          cost: currency.format(product.averageCost),
          input:
            watch('supplyProductId') === product.id ? (
              <Input
                allowComma={true}
                control={control}
                name="quantity"
                placeholder="Cantidad (*)"
                rules={{
                  required: 'Campo requerido',
                  ...(!Number.isNaN(Number(product.totalQuantity))
                    ? {
                        max: {
                          value: Number(product.totalQuantity),
                          message:
                            Number(product.totalQuantity) > 0
                              ? `La cantidad no puede ser mayor que ${Number(product.totalQuantity)}`
                              : 'No se puede agregar este producto',
                        },
                      }
                    : {}),
                  min: {
                    value: 0.01,
                    message: 'La cantidad debe ser mayor a 0',
                  },
                }}
                type="number"
              />
            ) : (
              ''
            ),
        },
      })
    )
  //---------------------------------------------------------------------------------------------

  return (
    <>
      <SearchComponent findAction={setSearch} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5 max-h-96 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-100">
          {outLoading ? (
            <SpinnerLoading text="Buscando producto" />
          ) : data.length === 0 && !search ? (
            <EmptyList
              subTitle="Inserte un criterio de búsqueda"
              title="Buscar Producto"
            />
          ) : data.length === 0 && search ? (
            <EmptyList
              subTitle="Inserte otro criterio de búsqueda"
              title="Producto no encontrado"
            />
          ) : (
            <CustomRadio
              action={() => clearErrors()}
              control={control}
              data={data}
              name="supplyProductId"
            />
          )}
        </div>
        <div className="flex justify-end p-2">
          <Button color="slate-600" name="Agregar" type="submit" />
        </div>
      </form>
    </>
  )
}

//-----------------------------------------------------------------------------------------------------------

//Update Quantity Modal ------------------------------------------------------------------------------------
interface UpdateQuantInt {
  currentQuant: number
  updateQuant: SubmitHandler<Record<string, number>>
}

const UpdateQuant = ({ currentQuant, updateQuant }: UpdateQuantInt) => {
  const { control, handleSubmit } = useForm()

  return (
    <form onSubmit={handleSubmit(updateQuant)}>
      <Input
        allowComma={true}
        control={control}
        defaultValue={currentQuant}
        label="Cantidad"
        name="quantity"
        rules={{ required: 'Debe insertar una cantidad' }}
        type="number"
      />
      <div className="flex justify-end py-2">
        <Button color="slate-600" name="Aceptar" type="submit" />
      </div>
    </form>
  )
}

//Costos Fijos --------------------------------------------------------------

//Componente de Costo Fijo -----------------------------------------------------------------------------------
interface FixCost {
  fixedCost?: FixedCost
  close: Function
}

const FixedCosts = ({ fixedCost, close }: FixCost) => {
  const { fixedCostCategories } = useAppSelector((state) => state.nomenclator)
  const { denyRoles, getAllFixedsCost } = useServer()
  const { control, handleSubmit, reset, watch, setValue, getValues } = useForm()
  const { addFixedCost, editFixedCost, deleteFixedCost, isFetching } =
    useServerProduct()
  const { product, updateFixedCostState, updateStockProductState } =
    useContext(DetailProductContext)
  const [view, setView] = useState('form')
  useEffect(() => {
    if (!fixedCostCategories) getAllFixedsCost()
  }, [])

  const costCategories: SelectInterface[] =
    fixedCostCategories?.map((cat) => ({
      id: cat.id,
      name: cat.name,
    })) ?? []

  const onSubmit: SubmitHandler<Record<string, number>> = (data) => {
    const dataToSend = {
      costAmount: data['costAmount'],
      description: data['description'],
      fixedCostCategoryId: data['fixedCostCategoryId'],
      type: data['type'],
    }
    if (typeCost === 'percent') {
      dataToSend.costAmount = data['costAmountPercent']
    }
    if (fixedCost) {
      const callback = (cost: FixedCost, id: number) => {
        reset()
        close()
        updateFixedCostState &&
          updateFixedCostState(cost, id, updateStockProductState)
      }
      editFixedCost(fixedCost.id, dataToSend, callback)
    } else {
      const callback = (cost: FixedCost) => {
        reset()
        close()
        updateFixedCostState &&
          updateFixedCostState(cost, undefined, updateStockProductState)
      }
      product &&
        addFixedCost({ ...dataToSend, productId: product.id }, callback)
    }
  }

  //----------------------------------------------------------------------------------

  //Delete cost ---------------------------------------------------------------
  const deleteCost = (id?: number) => {
    const callback = (id: number) => {
      reset()
      updateFixedCostState &&
        updateFixedCostState(undefined, id, updateStockProductState)
      close()
    }
    deleteFixedCost(id ?? 0, callback)
  }
  //--------------------
  const typeCost = watch('type') ?? fixedCost?.type ?? 'fixed'
  return (
    <>
      {view === 'form' && (
        <div className="relative">
          <div className="flex w-full items-center justify-between pe-6 text-center">
            {fixedCost ? (
              <h5 className="text-lg font-bold text-gray-600">
                Editar {fixedCost.description}
              </h5>
            ) : (
              <h5 className="text-lg font-bold text-gray-600">
                Nuevo Costo/Gasto Fijo
              </h5>
            )}
            {fixedCost && (
              <Button
                action={() => setView('delete')}
                color="red-400"
                icon={
                  <TrashOutline
                    className="h-5 text-gray-500"
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                    stroke={'#f87171'}
                  />
                }
                outline
              />
            )}
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={'mt-3 w-full'}>
              <div className="mt-4 flex flex-row gap-4">
                <div>
                  <SingleRadio
                    checked={typeCost === 'fixed'}
                    control={control}
                    label="Monto fijo"
                    name="type"
                    value={'fixed'}
                  />
                </div>
                <div>
                  <SingleRadio
                    checked={typeCost === 'percent'}
                    control={control}
                    label="Por porciento"
                    name="type"
                    value={'percent'}
                  />
                </div>
              </div>
            </div>
            <div className="mt-5 grid grid-cols-2 gap-3">
              <div className={`${typeCost === 'fixed' ? 'visible' : 'hidden'}`}>
                <Input
                  control={control}
                  defaultValue={fixedCost?.costAmount ?? ''}
                  label={'Monto'}
                  name="costAmount"
                  numberAsCurrency={{ precision: 2 }}
                  placeholder="Monto"
                  type="number"
                />
              </div>

              <div
                className={`${typeCost === 'percent' ? 'visible' : 'hidden'}`}
              >
                <Input
                  control={control}
                  defaultValue={fixedCost?.costAmount ?? ''}
                  label={'Porciento'}
                  name="costAmountPercent"
                  placeholder="Porciento"
                  rules={
                    typeCost === 'percent'
                      ? {
                          max: {
                            value: 100,
                            message: 'El monto no puede ser mayor a 100',
                          },
                          min: {
                            value: 0,
                            message: 'El monto no puede ser menor a 0',
                          },
                        }
                      : undefined
                  }
                  type="number"
                />
              </div>
              <Select
                control={control}
                data={costCategories ?? []}
                defaultValue={fixedCost?.fixedCostCategory?.id}
                label={'Categoría'}
                name="fixedCostCategoryId"
              />
            </div>
            <div className="mt-2 w-full">
              <TextArea
                control={control}
                defaultValue={product?.elaborationSteps}
                label="Descripción"
                name="description"
              />
            </div>

            <div className="inline-flex w-full justify-end gap-2 pt-3">
              {denyRoles(['AUDITOR']) && (
                <Button
                  color="slate-600"
                  loading={isFetching}
                  name={`${fixedCost ? 'Actualizar' : 'Crear'}`}
                  type="submit"
                />
              )}
            </div>
          </form>
        </div>
      )}
      {view === 'delete' && (
        <AlertContainer
          loading={isFetching}
          onAction={() => deleteCost(fixedCost?.id ?? 0)}
          onCancel={() => close()}
          text={`Seguro que desea continuar?`}
          title={`Eliminar ${fixedCost?.description ?? ''}`}
        />
      )}
    </>
  )
}
//------------------------------------------------------------------------------------------

//Main Component ---------------------------------------------------------------------------------

const Ficha = () => {
  const { denyRoles, allowRoles } = useServer()

  const { product, manageSupplies, updateStockProductState, updateProduct } =
    useContext(DetailProductContext)
  const { business } = useAppSelector((state) => state.init)
  const [dataTable, setDataTable] = useState<SuppliesInterface[]>([])
  const [addModal, setAddModal] = useState(false)
  const [editModal, setEditModal] = useState<{
    idx: number | null
    state: boolean
  }>({ idx: null, state: false })
  const [fixCostModal, setFixCostModal] = useState<{
    state: boolean
    current?: number
  }>({ state: false })

  useEffect(() => {
    product?.supplies && setDataTable(product.supplies)
  }, [])

  const precission = Number(
    business?.configurationsKey.find(
      (item) => item.key === 'precission_after_coma'
    )?.value
  )

  const addSuplies = (data: ProductInterface & { quantity: number }) => {
    setDataTable([
      ...dataTable,
      {
        id: 0,
        quantity: data.quantity,
        supply: {
          id: data.id,
          averageCost: data.averageCost,
          measure: data.measure,
          name: data.name,
          type: data.type,
        },
      },
    ])
    setAddModal(false)
  }

  const updateQuantity: SubmitHandler<Record<string, number>> = (data) => {
    const nextData = [...dataTable]
    if (editModal.idx !== null) {
      const idx = editModal.idx
      nextData.splice(idx, 1, {
        ...nextData[idx],
        id: 0,
        quantity: data.quantity,
      })
    }
    setDataTable(nextData)
    setEditModal({ state: false, idx: null })
  }

  const deleteSupply = (idx: number) => {
    const nextData = [...dataTable]
    nextData.splice(idx, 1, { ...nextData[idx], id: -1 })
    setDataTable(nextData)
    setEditModal({ state: false, idx: null })
  }

  const undelete = (idx: number) => {
    const nextData = [...dataTable]
    nextData.splice(idx, 1, { ...nextData[idx], id: 2 })
    setDataTable(nextData)
    setEditModal({ state: false, idx: null })
  }

  const fetchSupplyUpdate = () => {
    const dataToSend = dataTable.filter((item) => item.id !== -1)
    const data = dataToSend.map((item) => ({
      supplyProductId: item.supply.id,
      quantity: item.quantity,
    }))
    !supplyNoAccess.includes(product!.type) &&
      manageSupplies &&
      // watch("performance") > 1
      //   ? manageSupplies(product?.id, { products: data, performance: watch("performance") }, updateStockProductState)
      //   : manageSupplies(product?.id, { products: data, performance: 1 }, updateStockProductState)
      manageSupplies(
        product?.id,
        {
          products: data,
          performance: watch('performance'),
        },
        updateStockProductState
      )
    updateProduct &&
      updateProduct(
        product?.id,
        {
          netCost: watch('netCost'),
        },
        updateStockProductState
      )
  }

  //Data for table of supplies---------------------------------------------------------------------------------
  let total = 0
  let tableData: DataTableInterface[] = []
  dataTable.forEach((item, idx) => {
    tableData.push({
      rowId: item.supply.id,
      boldRow: item.id === 0,
      deletedRow: item.id === -1,
      payload: {
        Producto: item.supply.name,
        Tipo: <ProductTypeBadge type={item.supply.type} />,
        Cantidad: item.quantity,
        U_Medida: translateMeasure(item.supply.measure),
        U_Costo: formatCurrency(
          item.supply.averageCost * item.quantity,
          business?.costCurrency ?? 'CUP',
          precission
        ),
        '': (
          <div className="flex gap-1">
            {item.id !== -1 ? (
              <>
                <Button
                  action={() => setEditModal({ idx, state: true })}
                  color="yellow-300"
                  icon={<PencilIcon className="h-4 text-yellow-500" />}
                  outline
                />
                <Button
                  action={() => deleteSupply(idx)}
                  color="red-500"
                  icon={<TrashIcon className="h-4 text-red-500" />}
                  outline
                />
              </>
            ) : (
              <Button
                action={() => undelete(idx)}
                color="gray-500"
                icon={<ArrowUturnLeftIcon className="h-4 text-gray-500" />}
                outline
              />
            )}
          </div>
        ),
      },
    })
    total += item.supply.averageCost * item.quantity
  })

  tableData.length !== 0 &&
    tableData.push({
      payload: {
        Producto: <p className="text-sm font-semibold">Subtotal</p>,
        Tipo: '',
        Cantidad: '',
        U_Medida: '',
        U_Costo: (
          <p className="text-sm font-semibold">
            {'$' +
              formatCurrency(
                total,
                business?.costCurrency ?? 'CUP',
                precission
              )}
          </p>
        ),
        '': '',
      },
    })

  let tableTitles = ['Producto', 'Tipo', 'Cantidad', 'U_Medida', 'U_Costo', '']

  if (!allowRoles(['OWNER', 'MANAGER_COST_PRICES'])) {
    tableTitles = ['Producto', 'Tipo', 'Cantidad', 'U_Medida', '']
    tableData = [...tableData].map(({ payload, ...rest }) => {
      const { U_Costo, ...payloadWithoutCosto } = payload
      return { ...rest, payload: payloadWithoutCosto }
    })
  }

  const actions: BtnActions[] = []

  if (denyRoles(['AUDITOR'])) {
    actions.push({
      title: 'Nuevo producto',
      action: () => setAddModal(true),
      icon: <PlusIcon className="h-5" />,
    })
  }

  //----------------------------------------------------------------------------------------------------

  //Data for table fixed Cost ----------------------------------------------------
  let totalCost = 0
  const costTitles = ['Descripción', 'Monto', 'Categoría']
  const costData: DataTableInterface[] = []

  product?.fixedCosts?.forEach((item) => {
    costData.push({
      rowId: item.id,
      payload: {
        Descripción: item.description,
        Monto: `$${item.type === 'percent' ? formatCurrency((item.costAmount / 100) * (product?.netCost ?? 0), business?.costCurrency, precission) : formatCurrency(item.costAmount, business?.costCurrency, precission)}`,
        Categoría: item.fixedCostCategory?.name ?? '-',
      },
    })
    totalCost +=
      item.type === 'percent'
        ? (item.costAmount / 100) * (product?.netCost ?? 0)
        : item.costAmount
  })
  costData.length !== 0 &&
    costData.push({
      payload: {
        Descripción: <p className="text-sm font-semibold">Subtotal</p>,
        Monto: (
          <p className="text-sm font-semibold">
            {'$' +
              formatCurrency(
                totalCost,
                business?.costCurrency ?? 'CUP',
                precission
              )}
          </p>
        ),
        '': '',
      },
    })

  const rowActionCost = (id?: number) =>
    setFixCostModal({ state: true, current: id })

  const costActions: BtnActions[] = [
    {
      title: 'Insertar costo/gasto',
      icon: (
        <Plus
          className="h-5"
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      ),
      action: () => setFixCostModal({ state: true }),
    },
  ]
  //----------------------------------------------------------------------------------

  const { control, watch } = useForm()

  return (
    <div>
      <div className="h-[34rem] overflow-y-auto rounded-md border border-slate-300 p-5 pr-5 scrollbar-thin scrollbar-thumb-gray-50">
        {allowRoles(['OWNER', 'MANAGER_COST_PRICES']) && (
          <div className={'flex flex-col'}>
            {(product?.supplies ?? []).length === 0 &&
              tableData.length === 0 && (
                <div className="mb-1 inline-flex">
                  <Input
                    control={control}
                    defaultValue={product?.netCost}
                    disabled={product?.supplies.length !== 0}
                    label={`Costo neto de compra ponderado en ${business?.costCurrency}:`}
                    name="netCost"
                    numberAsCurrency={{ precision: precission }}
                    type="number"
                  />
                </div>
              )}

            <div className="mb-4 inline-flex">
              <span className="mt-3 font-semibold uppercase text-gray-600">{`Costo total: $${formatCurrency(
                product?.recipe
                  ? product.recipe.unityToBeProducedCost
                  : (product?.supplies ?? []).length === 0 &&
                      tableData.length === 0
                    ? Number(product?.netCost ?? 0) + totalCost
                    : totalCost + total,
                business?.costCurrency,
                precission
              )}`}</span>
            </div>
          </div>
        )}
        {!performanceNoAccess.includes(product!.type) && (
          <div className="">
            <div className="">
              <Input
                allowComma={true}
                control={control}
                defaultValue={product?.performance ? product?.performance : 1}
                label="Rendimiento"
                name="performance"
                rules={{ required: 'Este campo es requerido' }}
                type="number"
              />
            </div>

            {watch('performance') > 1 &&
              allowRoles(['OWNER', 'MANAGER_COST_PRICES']) && (
                <div className="inline-flex pb-3">
                  <span className="font-semibold uppercase text-gray-600">{`COSTO EN BASE A RENDIMIENTO: $${formatCurrency(
                    product?.recipe
                      ? product.recipe.unityToBeProducedCost
                      : (product?.supplies ?? []).length === 0 &&
                          tableData.length === 0
                        ? ((product?.netCost ?? 0) + totalCost) /
                          watch('performance')
                        : (totalCost + total) / watch('performance'),
                    business?.costCurrency,
                    precission
                  )}`}</span>
                </div>
              )}
          </div>
        )}

        {product?.recipe ? (
          <div className="rounded-md border border-gray-300 bg-gray-100 p-5">
            Este producto está asociado a la receta:{' '}
            <span className="font-semibold">{product.recipe.name}</span>
          </div>
        ) : (
          !supplyNoAccess.includes(product!.type) && (
            <>
              <div>
                <h5 className="py-3 text-sm font-semibold text-gray-700">
                  Costos de materia prima
                </h5>
                <GenericTable
                  actions={actions}
                  tableData={tableData}
                  tableTitles={tableTitles}
                />
              </div>
            </>
          )
        )}
        {allowRoles(['OWNER', 'MANAGER_COST_PRICES']) &&
          !fixedCostNoAccess.includes(product!.type) && (
            <>
              <h5 className="text-md mt-10 font-semibold text-gray-700">
                Costos/Gastos fijos
              </h5>
              <p className={'mb-5 text-sm font-thin italic text-gray-700'}>
                Costos calculados luego de compra
              </p>
              <GenericTable
                actions={costActions}
                rowAction={rowActionCost}
                tableData={costData}
                tableTitles={costTitles}
              />
            </>
          )}
      </div>
      <div className="flex justify-end py-4">
        {denyRoles(['AUDITOR']) && (
          <Button
            action={fetchSupplyUpdate}
            color="slate-600"
            name="Actualizar"
          />
        )}
      </div>
      {addModal && (
        <Modal close={setAddModal} size="m" state={addModal}>
          <NewElement addElement={addSuplies} />
        </Modal>
      )}

      {editModal.state && editModal.idx !== null && (
        <Modal
          close={(state: boolean) => setEditModal({ state, idx: null })}
          state={editModal.state}
        >
          {
            <UpdateQuant
              currentQuant={dataTable[editModal.idx].quantity}
              updateQuant={updateQuantity}
            />
          }
        </Modal>
      )}

      {fixCostModal.state && (
        <Modal
          close={() => setFixCostModal({ state: false })}
          state={fixCostModal.state}
        >
          <FixedCosts
            close={() => setFixCostModal({ state: false })}
            fixedCost={product?.fixedCosts.find(
              (item) => item.id === fixCostModal.current
            )}
          />
        </Modal>
      )}
    </div>
  )
}

//--------------------------------------------------------------------------------------------------

export default Ficha
